import { render } from "./StrongWoolIndexChart.vue?vue&type=template&id=9237383e"
import script from "./StrongWoolIndexChart.vue?vue&type=script&lang=js"
export * from "./StrongWoolIndexChart.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__